/**
 * A SubViewport's tonemap pass (`toneMapPass.ts`), mounted in the world the viewport draws, with the
 * camera, the exposure and the Environment the pass draws that world through.
 */
import { useLayoutEffect, useMemo } from 'react';
import { useToneMapPass } from './toneMapPass';
import { usePassToneMap } from './passToneMap';
import { useOptionalExposureFactor, usePassCameraPath } from './worldExposure';
/**
 * Mounts the world buffer and the tonemap pass of one offscreen viewport in the world it sits in,
 * and hands them to `stage` while it stays mounted. A pass in a portal of its own world mounts it
 * inside the portal. It reads the camera, the exposure and the auto exposure of the attributes around
 * it (`ViewportPassAttributes`), and the Environment the pass draws with (`ViewportPassEnvironment`).
 *
 * @canonical Godot's tonemap pass into a render target
 */
export function OffscreenToneMapStage({ stage, ...options }) {
    const toneMap = useOffscreenToneMap(options);
    useLayoutEffect(() => {
        stage.current = toneMap;
        return () => {
            if (stage.current === toneMap)
                stage.current = null;
        };
    }, [stage, toneMap]);
    return null;
}
function useOffscreenToneMap(options) {
    const pass = useToneMapPass(options);
    const exposure = useOptionalExposureFactor();
    const cameraPath = usePassCameraPath();
    const environment = usePassToneMap().settings;
    return useMemo(() => ({ ...pass, cameraPath, exposure, environment }), [pass, cameraPath, exposure, environment]);
}
//# sourceMappingURL=offscreenToneMap.js.map